"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { getLocaleAndCanonicalPath } from "@/lib/path/localePath";

export default function NewRelicPageName() {
  const pathname = usePathname();

  useEffect(() => {
    const { canonicalPath } = getLocaleAndCanonicalPath(pathname);
    (window.newrelic as any)?.setCurrentRouteName?.(canonicalPath);
  }, [pathname]);

  return null;
}
